import {
    LoadingController,
    ModalController,
    NavController,
    NavParams,
    Platform,
    ToastController,
    AlertController,
    PopoverController
} from '@ionic/angular';
// import {any, PlayerList, PlayerHomeInfo} from '../../../data/player-data';
import {
    FriendService
} from '../../../../providers/friend-service/friend-service';
import {
    NewContactPage
} from '../../new-contact/new-contact.page';
import {
    NewGameInfo
} from '../../../../data/game-round';
import {
    Keyboard
} from '@ionic-native/keyboard/ngx';
import {
    Component
} from '@angular/core';
import {
    MessageDisplayUtil
} from '../../../../message-display-utils';
import {
    PlayerService
} from '../../../../providers/player-service/player-service';
import {
    FormGroup,
    FormBuilder,
    FormControl,
    Validators,
    AbstractControl
} from '@angular/forms';
import {
    TeeTimeBookingPlayer,
    PlayerData,
    ClubCourseData,
    TeeTimeBookingOptions,
    TeeTimeBooking,
    TeeTimeSlotDisplay
} from '../../../../data/mygolf.data';
// import { PlayerHomeDataService } from '../../../redux/player-home';
import {
    Observable
} from 'rxjs';
import {
    isTrueProperty
} from 'ionic-angular/util/util';
import {
    ClubFlightService
} from '../../../../providers/club-flight-service/club-flight-service';
import {
    PlayerListPage
} from '../player-list/player-list.page';
import {
    ClubInfo,
    CourseInfo
} from '../../../../data/club-course';
import {
    ClubService
} from '../../../../providers/club-service/club-service';
import {
    CourseBox
} from '../course-box/course-box.page';
import * as moment from 'moment';
import {
    SelectDatesPage
} from '../select-dates/select-dates.page';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export interface NonMg2uPlayer {
    playerName: string;
    email: string;
    gender: string;
}
@Component({
    templateUrl: 'edit-teetime-settings.html',
    selector: 'edit-teetime-settings-page'
})
export class EditTeeTimeSettingsPage {
    listMode: string = 'friends';
    openedModal: boolean = false;
    playersToExclude: Array<TeeTimeBookingPlayer> = [];
    gameInfo: NewGameInfo;
    // listFriends: PlayerList;

    // friends: Array<any> = [];
    // players: Array<any> = [];
    searchQuery: string = "";
    searchPlayers: string = "";

    // availablePlayers: Array<any> = [];
    nonMg2uPlayer: NonMg2uPlayer;
    addPlayerForm: FormGroup;
    playerName: AbstractControl;
    email: AbstractControl;
    gender: AbstractControl;
    phone: AbstractControl;

    _playerName: string;
    _email: string;
    _gender: string = 'M';
    _phone: string;

    isCovid: boolean = true;

    // public playerHomeInfo$: Observable<PlayerHomeInfo>;
    // public player$: Observable<any>;

    // currentPlayerId: number;
    // _newPlayer: any;

    searchByMembership: string;
    searchById: number;
    clubId: number;
    groupBookPlayer: PlayerData;
    clubInfo: ClubInfo;
    fromTime: string = '07:00';
    toTime: string = '10:00';
    selectedCourse: ClubCourseData;
    playersPerFlight: string = '1';
    buggiesPerFlight: string = '1';
    caddiesPerFlight: string = '1';
    groupSlots: number = 5;
    optionCourse: CourseInfo;
    startDate: string = moment().add(1, 'days').format("YYYY-MM-DD");

    bookingOptions: TeeTimeBookingOptions;
    bookingSlot: TeeTimeBooking;
    teeTimeSlotDisplay: TeeTimeSlotDisplay;
    teeTimeSettings: any;
    currentSettings: any;
    teeSlotNew: boolean;
    viewCurrentSettings: boolean = false;
    totalSlotsSelected: number = 0;
    singleMode: boolean = true;
    _bookingOnline: boolean = true;
    constructor(private nav: NavController,
        private navParams: NavParams,
        private modalCtl: ModalController,
        private loadCtl: LoadingController,
        private platform: Platform,
        private keyboard: Keyboard,
        private toastCtl: ToastController,
        private friendService: FriendService,
        private playerService: PlayerService,
        private fb: FormBuilder,
        private alertCtrl: AlertController,
        // private playerHomeService: PlayerHomeDataService,
        private flightService: ClubFlightService,
        private loadingCtrl: LoadingController,
        private popoverCtl: PopoverController,
        private clubService: ClubService) {
        this.openedModal = navParams.get("openedModal");
        let exclusion = navParams.get("playersToExclude");
        this.gameInfo = navParams.get("gameInfo");
        this.clubId = navParams.get("clubId");
        this.clubInfo = navParams.get("clubInfo");
        this.bookingSlot = navParams.get("bookingSlot");
        this.teeTimeSlotDisplay = navParams.get("teeTimeSlotDisplay");
        this.bookingOptions = navParams.get("bookingOptions");
        this.teeSlotNew = navParams.get("teeSlotNew");
        this.singleMode = navParams.get("singleMode");
        this.totalSlotsSelected = navParams.get("totalSlotsSelected");
        if (exclusion) {
            this.playersToExclude.push(...exclusion);
        }



        this.addPlayerForm = this.fb.group({
            playerName: new FormControl('', [<any>Validators.required, <any>Validators.maxLength(50)]),
            email: new FormControl('', [<any>Validators.required, <any>Validators.email, <any>Validators.maxLength(50)]),
            gender: new FormControl('M'),
            phone: new FormControl('', [<any>Validators.required, Validators.minLength(7), <any>Validators.maxLength(50)]),
        })

        this.playerName = this.addPlayerForm.controls["playerName"];
        this.email = this.addPlayerForm.controls["email"];
        this.gender = this.addPlayerForm.controls["gender"];
        this.phone = this.addPlayerForm.controls["phone"];

        if (this.bookingSlot && this.bookingSlot.bookingMedium === 'WALKIN') this._bookingOnline = false
        else if (this.bookingSlot && this.bookingSlot.bookingMedium === 'ONLINE') this._bookingOnline = true




        if (this.singleMode && this.teeSlotNew) {

            this.teeTimeSettings = {
                buggyRequired: !this.teeTimeSlotDisplay.slot.allowWalking,
                maxPlayersPerBuggy: this.teeTimeSlotDisplay.slot.maxPlayersPerBuggy,
                caddieRequired: this.teeTimeSlotDisplay.slot.caddyMandatory,
                maxPlayersPerCaddie: this.teeTimeSlotDisplay.slot.maxPlayersPerCaddy,
                maxPlayers: this.teeTimeSlotDisplay.slot.maxPlayers,
                bookingMedium: this.bookingSlot.bookingMedium
            }
        } else if (this.singleMode && !this.teeSlotNew) {
            this.teeTimeSettings = {
                buggyRequired: !this.bookingSlot.slotAssigned.allowWalking,
                maxPlayersPerBuggy: this.bookingSlot.slotAssigned.maxPlayersPerBuggy,
                caddieRequired: this.bookingSlot.slotAssigned.caddyMandatory,
                maxPlayersPerCaddie: this.bookingSlot.slotAssigned.maxPlayersPerCaddy,
                maxPlayers: this.bookingSlot.slotAssigned.maxPlayers,
                bookingMedium: this.bookingSlot.bookingMedium
            }

        } else {
            this.teeTimeSettings = {
                buggyRequired: null,
                maxPlayersPerBuggy: 1,
                caddieRequired: null,
                maxPlayersPerCaddie: 1,
                maxPlayers: 6,
                bookingMedium: 'WALKIN'
            }
        }

        this.currentSettings = Object.assign({}, this.teeTimeSettings)



    }

    ionViewDidLoad() {



    }

    ionViewWillLeave() {

        if (this.platform.is('ios') || this.platform.is('capacitor')) { }
        // this.keyboard.close();
    }



    friendSelected(item: any) {
        let _isNewPlayer = item ? false : true;

        this.modalCtl.dismiss({
            item: item,
            isCovid: true,
            newPlayer: _isNewPlayer,
            playerDetails: this.addPlayerForm.value,
            playerContact: ''
        });
        // if(this.isCovid) {
        //     this._additionalForm(item);
        // } else {
        //     this.viewCtl.dismiss(item);
        // }
    }

    getImage(item: any) {
        if (item.thumbnail)
            return item.thumbnail;
        // else if (item.photoUrl)
        //     return item.photoUrl;
        else
            return "img/default_user.png";
    }



    async newContact() {
        let newContactModal = await this.modalCtl.create({
            component: NewContactPage,
            componentProps: {
                openedAsDialog: true
            }
        });
        newContactModal.onDidDismiss().then((data: any) => {
            //Check whether the club info is passed
            if (data) {
                this.playerSelected(null, data);
            }
        });
        newContactModal.present();
    }

    playerSelected(event, item: any) {

        if (this.openedModal) {
            this.modalCtl.dismiss(item);
        }
    }

    close() {
        this.modalCtl.dismiss();
    }

    async applySettings() {
        if (this._bookingOnline) this.teeTimeSettings.bookingMedium = 'ONLINE'
        else this.teeTimeSettings.bookingMedium = 'WALKIN'
        if (this.teeTimeSettings.maxPlayersPerBuggy === 0 || this.teeTimeSettings.maxPlayersPerCaddie === 0) {
            let alert = await this.alertCtrl.create({
                header: 'Max Players Per Buggy / Caddie',
                // subTitle: 'Selected date is '+ _date,
                message: 'Since <b>0</b> value is set for Max Players Per Buggy / Caddie,<br>please make sure to unpair any buggy or caddie', //'Selected date is ' + '<b>' + _date + '</b>',
                buttons: [{
                    text: 'Okay',
                    handler: () => {

                        this.modalCtl.dismiss(this.teeTimeSettings);
                    }
                }]
            });
            alert.present();
        } else this.modalCtl.dismiss(this.teeTimeSettings);
    }




    async _additionalForm(item?: any) {
        let _isNewPlayer = (item) ? false : true;

        // <h3 style="color:red">COVID-19 Important Notice</h3>
        let _message = `<img item-left src="assets/img/booking-item-covid.svg" style="float:left;width: 4em;margin: 0.5em;" />
        
        <h4 item-right style="color:red;white-space: normal;">MGA recommends that all players should include their
            addresses for contact tracing</h4>`;
        let alert = await this.alertCtrl.create({
            header: 'COVID-19 Important Notice',
            // subTitle: 'Selected date is '+ _date,
            message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
            // buttons: ['Close']
            inputs: [{
                name: 'playerContact',
                placeholder: 'Enter address'
            }],
            buttons: [{
                text: 'Proceed',
                // role: 'cancel',
                handler: (playerContact) => {

                    this.modalCtl.dismiss({
                        item: item,
                        isCovid: true,
                        newPlayer: _isNewPlayer,
                        playerDetails: this.addPlayerForm.value,
                        playerContact: playerContact

                    });
                    // this.nav.push(BookingHomePage, {
                    //     fromBookNow: true
                    // })
                    // 
                }
            }]
        });
        alert.present();


        // let newContactModal = this.modalCtl.create(NewContactPage, {
        //     openedAsDialog: true
        // });
        // newContactModal.onDidDismiss((data: any) => {
        //     //Check whether the club info is passed
        //     if (data) {
        //         this.playerSelected(null, data);
        //     }
        // });
        // newContactModal.present();


    }

    async onKeySearchPlayerByEmail() {

        let _valueChanged = this.email.valueChanges.pipe(debounceTime(1500), distinctUntilChanged());
        let loader = await this.loadingCtrl.create({
            showBackdrop: false,
            duration: 5000,
            message: 'Checking for existing player...'
        });
        // if(this.email.valid && _valueChanged) {
        if (this._email && this._email.length > 10) {

            // 

            // 

            // _valueChanged.subscribe(()=>{
            let _email = this._email; //this.email.value;

            // 
            this.flightService.getPlayerByEmail(_email)
                .subscribe((data: any) => {
                    loader.dismiss(data).then(() => {
                        if (data.length > 0 && data[0]) {

                            let _data = data[0]
                            // this.addPlayerForm['playerName']= data&&data.playerName?data.playerName:data.firstName+' '+data.lastName;
                            // this.addPlayerForm['gender'] = data&&data.gender?data.gender:'M';
                            // this.addPlayerForm['phone'] = data.address&&data.address.phone1?data.address.phone1:null;
                            this._playerName = (_data && _data.playerName) ? _data.playerName : '';
                            this._gender = (_data && _data.gender) ? _data.gender : 'M';
                            this._phone = (_data.addressInfo && _data.addressInfo.phone1) ? _data.addressInfo.phone1 : null;

                            // this._newPlayer = _data;

                            // let msg = MessageDisplayUtil.getErrorMessage('Player Found', "Player found");
                            MessageDisplayUtil.showErrorToast('Player Found', this.platform, this.toastCtl, 5000, "bottom");
                        }

                    })
                })
            // })
        }
        // if(this.email.valid) {
        //     
        // this.flightService.getPlayerByEmail(this.email.value)
        // .subscribe((data)=>{
        //     
        // })
        // }
    }

    // onSearchPlayerByEmail() {
    //     if(this.email.valid) {
    //         this.flightService.getPlayerByEmail(this.email.value)
    //         .subscribe((data)=> {
    //             
    //         })
    //     }
    // }

    // checkAddMe() {
    //     let _hasMe: boolean = false;
    //     
    //     // this.playersToExclude.filter((tbp: TeeTimeBookingPlayer)=>{
    //     //    if(this.currentPlayerId && tbp.player.id === this.currentPlayerId) _hasMe = true
    //     //    else _hasMe = false
    //     // })

    //     
    //     return _hasMe;
    // }
    async searchBookingPlayer(slot: number) {
        // if (this.bookingSlot.bookingStatus === 'PaymentFull') {
        //     MessageDisplayUtil.showMessageToast('Full Payment have been made. Adding/Removing player is disabled.',
        //         this.platform, this.toastCtl, 3000, "bottom")
        //     return false;
        // }
        if (!this.searchById && !this.searchByMembership) {
            // this.searchByMembership[slot].length === 0
            let alert = await this.alertCtrl.create({
                header: 'Selecting player',
                // subTitle: 'Selected date is '+ _date,
                message: 'Enter membership / myG2u ID', //'Selected date is ' + '<b>' + _date + '</b>',
                buttons: ['Close']
            });
            alert.present();

            return false;
        }

        let loader = await this.loadingCtrl.create({
            showBackdrop: false,
            duration: 5000,
            message: 'Getting player...'
        });



        let _searchBy;



        // 
        // 
        loader.present().then(() => {
            if (this.searchById && this.searchById > 0) {
                _searchBy = this.searchById;

                this.flightService.getPlayerById(_searchBy)
                    .subscribe((response: any) => {
                        loader.dismiss().then(async () => {
                            let player = response.json();
                            // let _playerDetails: TeeTimeBookingPlayer = {};
                            // _playerDetails['walking'] = this.buggyRequired ? !this.buggyRequired : true
                            // _playerDetails['caddySelectionCriteria'] = {}
                            // _playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired ? this.caddyRequired : false

                            if (player) {
                                this.groupBookPlayer = player;
                                // this.checkBookingPlayer(player).then((playerOk) => {
                                //     
                                //     // if (playerOk) this.addPlayerToBooking({
                                //     //     playerId: player.id,
                                //     //     sequence: slot,
                                //     //     playerDetails: _playerDetails,
                                //     // });
                                // }, (error) => {
                                //     
                                // })

                            } else {
                                let alert = await this.alertCtrl.create({
                                    header: 'myGolf2u ID',
                                    // subTitle: 'Selected date is '+ _date,
                                    message: 'No player found for MG2U ID : <br>' + _searchBy, //'Selected date is ' + '<b>' + _date + '</b>',
                                    buttons: ['Close']
                                });
                                alert.present();
                            }
                        }, (error) => {
                            loader.dismiss().then(async () => {
                                if (error.status !== 200) {
                                    let alert = await this.alertCtrl.create({
                                        header: 'MyGolf2u ID',
                                        // subTitle: 'Selected date is '+ _date,
                                        message: 'No player found for MG2U ID : <br>' + _searchBy, //'Selected date is ' + '<b>' + _date + '</b>',
                                        buttons: ['Close']
                                    });
                                    alert.present();
                                }
                            });



                        });

                    });
            } else if (this.searchByMembership && this.searchByMembership.length > 0) {
                _searchBy = this.searchByMembership;



                this.flightService.searchPlayerByMembership(_searchBy, this.clubId)
                    .subscribe((player: Array<PlayerData>) => {
                        loader.dismiss().then(async () => {
                            let _playerDetails: TeeTimeBookingPlayer = {};
                            // _playerDetails['walking'] = this.buggyRequired ? !this.buggyRequired : true
                            _playerDetails['caddySelectionCriteria'] = {}
                            // _playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired ? this.caddyRequired : false

                            if (player && player.length > 0) {
                                let popover = await this.popoverCtl.create({
                                    component: PlayerListPage,
                                    componentProps: {
                                        // slot: slot,
                                        headerName: 'Players by Membership',
                                        playerList: player,
                                        forResultOnly: true
                                        // buggies: this.buggySlots,
                                        // courses: this.courses

                                    },
                                    showBackdrop: true

                                })
                                popover.onDidDismiss().then((data: any) => {
                                    if (data && data.selected) {
                                        this.checkBookingPlayer(data.player).then((playerOk) => {

                                            // if (playerOk) this.addPlayerToBooking({
                                            //     playerId: data.player.id,
                                            //     sequence: slot,
                                            //     playerDetails: _playerDetails,
                                            // });
                                        })

                                    }
                                });
                                popover.present();
                            } else {
                                let alert = await this.alertCtrl.create({
                                    header: this.clubInfo.clubName,
                                    // subTitle: 'Selected date is '+ _date,
                                    message: 'Club membership number ' + _searchBy + ' does not exist for this club', //'Selected date is ' + '<b>' + _date + '</b>',
                                    buttons: ['Close']
                                });
                                alert.present();
                            }

                        })

                    })



            }
        });

    }

    clearSearchPlayer(slot: number) {
        this.searchByMembership = null;
        this.searchById = null;
    }
    checkBookingPlayer(any?: any): Promise<boolean> {
        let _playerOk: boolean;
        return new Promise<any>(resolve => {
            // this.bookingSlot.bookingPlayers.forEach((tbp: TeeTimeBookingPlayer) => {
            //     
            //     
            //     if (tbp.player && tbp.player.id === any.id) {

            //         _playerOk = false;
            //         let alert = this.alertCtrl.create({
            //             // title: 'Remove Player',
            //             // subTitle: 'Selected date is '+ _date,
            //             message: 'Player is already in the flight', //'Selected date is ' + '<b>' + _date + '</b>',
            //             buttons: ['Close']
            //             // buttons: [{
            //             //         text: 'Close',
            //             //         handler: () => {
            //             //             // 
            //             //         }
            //             //     }
            //             // ]
            //         });
            //         alert.present();
            //     } else _playerOk = true;

            // })

            resolve(_playerOk)
        })
        // return _playerOk;
    }

    onDeleteBookingPlayer(slot: number) {
        this.groupBookPlayer = null;
        // player: TeeTimeBookingPlayer
        // 
        // let alert = this.alertCtrl.create({
        //     title: 'Remove Player',
        //     // subTitle: 'Selected date is '+ _date,
        //     message: 'Removing selected player from booking. Do you want to proceed?', //'Selected date is ' + '<b>' + _date + '</b>',
        //     // buttons: ['Close']
        //     buttons: [{
        //             text: 'Remove player',
        //             handler: () => {
        //                 this.deleteBookingPlayer(player);
        //                 // 
        //             }
        //         },
        //         {
        //             text: 'Close',
        //         }
        //     ]
        // });
        // alert.present();
    }
    onSelectCourse(event) {
        this.clubService.getClubCourses(this.clubId)
            .subscribe(async (courses: Array<CourseInfo>) => {

                let popover = await this.popoverCtl.create({
                    component: CourseBox,
                    componentProps: {
                        fromStarterList: true,
                        courses: courses,
                        excludeAll: false,
                    }
                });
                popover.onDidDismiss().then((data: any) => {

                    // this.getFlightStarterList();
                    if (data) {
                        if (data && data.courseId === 0) data.courseName = 'Any Available Courses'
                        // this.optionCourse = {}; 
                        // this.gameInfo.courses.push(data);

                        this.optionCourse = data;
                        // this.refreshTeeSlots({
                        //   clubCourseId: data.courseId,
                        //   isClub: false
                        // });
                    }
                });
                popover.present();
            })
    }
    async onSelectTimes() {
        let times = await this.modalCtl.create({
            component: SelectDatesPage,
            componentProps: {
                type: 'times',
                range: true,
                fromTime: this.fromTime,
                toTime: this.toTime,
            }
        });

        times.onDidDismiss().then((data: any) => {
            if (data) {
                this.fromTime = data.fromTime;
                this.toTime = data.toTime;
            }
        });

        times.present();
    }

    addBuggy(x: number) {
        if (x < 1 && this.teeTimeSettings.maxPlayersPerBuggy <= 1) return false;
        else if (x > 0 && this.teeTimeSettings.maxPlayersPerBuggy >= this.teeTimeSettings.maxPlayers) return false;
        // else if(x < 0 && this.playerReq <= this.bookingSlot.bookingPlayers.length) return false;
        else this.teeTimeSettings.maxPlayersPerBuggy += x;

        // if (x < 0) this.slots.pop()
        // else if(x > 0) this.slots.push(this.slots.length+1)
    }

    addCaddie(x: number) {
        if (x < 1 && this.teeTimeSettings.maxPlayersPerCaddie <= 1) return false;
        else if (x > 0 && this.teeTimeSettings.maxPlayersPerCaddie >= this.teeTimeSettings.maxPlayers) return false;
        // else if(x < 0 && this.playerReq <= this.bookingSlot.bookingPlayers.length) return false;
        else this.teeTimeSettings.maxPlayersPerCaddie += x;
        // if (x < 0) this.slots.pop()
        // else if(x > 0) this.slots.push(this.slots.length+1)
    }

}